import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const badges = [
  { value: '500+', label: 'Landlords on Waitlist' },
  { value: '100%', label: 'California Focused' },
  { value: '$1', label: 'Flat Rate Forever' },
  { value: 'Q3 2025', label: 'Launch Date' },
];

const TrustBadgesSection: React.FC = () => {
  return (
    <SectionBackground style={{ padding: '60px 20px', background: 'var(--bg-white)' }}>
      <div className="container">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '56px',
          flexWrap: 'wrap',
        }}>
          {badges.map((badge, idx) => (
            <div key={idx} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--primary)' }}>
                {badge.value}
              </div>
              <div style={{ color: 'var(--text-light)' }}>
                {badge.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default TrustBadgesSection; 